<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-links">
          <router-link to="/explorar/escribir-novelas" class="footer-link">Explorar</router-link>
          <router-link to="/blog" class="footer-link">Blog</router-link>
          <router-link to="/how-it-works" class="footer-link">¿Cómo funciona?</router-link>
          <a href="/#precios" class="footer-link">Precios</a>
          <router-link to="/terms-and-conditions" class="footer-link">Términos de uso</router-link>
        </div>
        <div class="footer-contact">
          <p class="footer-contact__label">Contacto</p>
          <a class="footer-link" href="mailto:escribonauta.cl@gmail.com">escribonauta.cl@gmail.com</a>
        </div>
        <div class="footer-text">
          <p>&copy; 2026 Escribonauta. Hecho con ❤️ para escritores.</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'HomeFooter',
})
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.footer {
  background: #1d3557;
  color: white;
  padding: 2rem 0;
  text-align: center;
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.5rem;
}

.footer-link {
  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
  font-size: 0.95rem;
  transition: color 0.2s ease;
}

.footer-link:hover {
  color: white;
}

.footer-contact {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
}

.footer-contact__label {
  margin: 0;
  color: rgba(255, 255, 255, 0.65);
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

@media (max-width: 768px) {
  .container {
    padding: 0 1rem;
  }
}
</style>
